import Reveal from '../../../shared/Reveal/Reveal';
import { useEconomicCalendarEventImpactContent } from '../../../../hooks/useEconomicCalendarEventImpactContent';
import highIcon from '../../../../assets/images/insights/eventimpact/ic1.svg';
import mediumIcon from '../../../../assets/images/insights/eventimpact/ic2.svg';
import lowIcon from '../../../../assets/images/insights/eventimpact/ic3.svg';
import './EventImpact.css';

const fallbackIcons = [highIcon, mediumIcon, lowIcon];

const EventImpact = () => {
  const { content, isLoading } = useEconomicCalendarEventImpactContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, items } = content;

  return (
    <section className="event-impact">
      <div className="event-impact__inner">
        <Reveal>
          <h2 className="event-impact__title">{title}</h2>
        </Reveal>

        <div className="event-impact__grid">
          {items.map(({ title: itemTitle, text, icon }, index) => (
            <Reveal key={itemTitle} delay={index * 80}>
              <article className="event-impact__item">
                <div className="event-impact__icon-wrap">
                  <img
                    className="event-impact__icon"
                    src={icon || fallbackIcons[index] || highIcon}
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <h3 className="event-impact__item-title">{itemTitle}</h3>
                <p className="event-impact__item-text">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventImpact;
